import type * as Types from 'app/types/graphql';

export type VariantPriceSelectFragment = Pick<
  Types.VariantPrice,
  'id' | 'baseID' | 'handle' | 'status' | 'title' | 'redirectURL' | 'sourceProductBaseID'
>;

export const VariantPriceSelectFragmentDoc = `
    fragment VariantPriceSelect on VariantPrice {
  id
  baseID
  handle
  status
  title
  redirectURL
  sourceProductBaseID
}
    `;
